import React, { useCallback, useEffect, useState } from 'react';
import { Badge, Card, Col, Container, Row } from 'react-bootstrap';
import { FaCogs, FaUsers, FaChartBar } from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import IndicacaoParametros from '~/Components/Indicacao/Parametros';
import Promotores from '~/Components/Indicacao/Promotores';
import { buscarPromotores } from '~/Services/Service';

export default function IndicacaoPage() {
  const [secaoAtiva, setSecaoAtiva] = useState(null);
  const [resumo, setResumo] = useState({ total: 0, ativos: 0, inativos: 0 });

  const carregarResumo = useCallback(async () => {
    try {
      const promotores = await buscarPromotores();
      const ativos = promotores.filter(p => p.status === 0).length;
      setResumo({
        total: promotores.length,
        ativos,
        inativos: promotores.length - ativos,
      });
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    carregarResumo();
  }, [carregarResumo]);

  const secoes = [
    {
      id: 'parametros',
      titulo: 'Parâmetros',
      descricao: 'Configurar empreendimentos e corretores',
      icone: <FaCogs />,
      cor: '#0747a6',
    },
    {
      id: 'indicadores',
      titulo: 'Indicadores',
      descricao: 'Gerenciar promotores externos',
      icone: <FaUsers />,
      cor: '#0747a6',
      badge: resumo.total > 0 ? resumo.total : null,
    },
  ];

  return (
    <>
      <style>{'\
        .indicacao-card {\
          transition: all 0.2s ease;\
          cursor: pointer;\
          border: 2px solid transparent;\
        }\
        .indicacao-card:hover {\
          transform: translateY(-2px);\
          box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;\
        }\
        .indicacao-card.ativo {\
          border-color: #0747a6;\
        }\
        .indicacao-resumo-item {\
          text-align: center;\
          padding: 0 12px;\
        }\
        .indicacao-resumo-item + .indicacao-resumo-item {\
          border-left: 1px solid #e9ecef;\
        }\
        @media (max-width: 768px) {\
          .indicacao-cards-row { flex-direction: column; }\
          .indicacao-resumo-row { flex-direction: column; gap: 8px; }\
          .indicacao-resumo-item { text-align: left; padding: 4px 0; border-left: none !important; }\
        }\
      '}</style>

      <Header title="Indicação" />
      <Container fluid className="px-3 py-3">
        <Card className="shadow-sm mb-3">
          <Card.Body className="py-2">
            <Row className="align-items-center">
              <Col md={4} className="d-flex align-items-center mb-2 mb-md-0">
                <FaChartBar style={{ color: '#0747a6', marginRight: 8, fontSize: '1.2rem' }} />
                <strong style={{ color: '#0747a6' }}>Resumo de Indicadores</strong>
              </Col>
              <Col md={8}>
                <div className="d-flex justify-content-end indicacao-resumo-row">
                  <div className="indicacao-resumo-item">
                    <small className="text-muted d-block">Total</small>
                    <strong>{resumo.total}</strong>
                  </div>
                  <div className="indicacao-resumo-item">
                    <small className="text-muted d-block">Ativos</small>
                    <strong style={{ color: '#28a745' }}>{resumo.ativos}</strong>
                  </div>
                  <div className="indicacao-resumo-item">
                    <small className="text-muted d-block">Inativos</small>
                    <strong style={{ color: '#6c757d' }}>{resumo.inativos}</strong>
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <Row className="mb-3 indicacao-cards-row">
          {secoes.map(item => (
            <Col md={6} key={item.id} className="mb-2 mb-md-0">
              <Card
                className={
                  'shadow-sm indicacao-card' +
                  (secaoAtiva === item.id ? ' ativo' : '')
                }
                onClick={() =>
                  setSecaoAtiva(prev => (prev === item.id ? null : item.id))
                }
              >
                <Card.Body className="d-flex align-items-center py-3">
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 8,
                      backgroundColor: secaoAtiva === item.id ? item.cor : '#f0f4f8',
                      color: secaoAtiva === item.id ? '#fff' : item.cor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.4rem',
                      marginRight: 16,
                      transition: 'all 0.2s',
                      flexShrink: 0,
                    }}
                  >
                    {item.icone}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="d-flex align-items-center">
                      <strong style={{ fontSize: '1rem' }}>{item.titulo}</strong>
                      {item.badge && (
                        <Badge
                          pill
                          variant="primary"
                          style={{
                            marginLeft: 8,
                            backgroundColor: '#0747a6',
                            fontSize: '0.75rem',
                          }}
                        >
                          {item.badge}
                        </Badge>
                      )}
                    </div>
                    <small className="text-muted">{item.descricao}</small>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {secaoAtiva === 'parametros' && <IndicacaoParametros />}
        {secaoAtiva === 'indicadores' && <Promotores />}
      </Container>
    </>
  );
}
